import { lockField as lockFieldBackend } from '@/backend/lockField'
import type { Field } from './Fields/types'
import { useProjectStore } from './useProjectStore'

export const useFieldLock = () => {
  const projectStore = useProjectStore()

  const toggleFieldLock = async (field: Field) => {
    const newGroundTruth = !field.groundTruth

    const response = await lockFieldBackend({
      workspaceId: field.workspaceId,
      projectId: field.projectId,
      entityId: field.entityId,
      propertyId: field.propertyId,
      groundTruth: newGroundTruth,
    })

    projectStore.updateField({ ...field, groundTruth: newGroundTruth })

    if (response.ok) {
      return
    }

    if (response.error) {
      projectStore.updateField({ ...field, groundTruth: !newGroundTruth })
      throw new Error(response.error.message)
    }
  }

  return {
    toggleFieldLock,
  }
}
